<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="dashboard">
      <div class="row" v-if="userData && !parseInt(userData.verified)" style="margin-top: 15px">
        <div class="col-xs-9">
          <div class="alert alert-danger" role="alert">{{ _('Your email address needs to be verified. Please click the verification link in the email we sent you when the shop was created.') }}</div>
        </div>
        <div class="col-xs-3" style="text-align: right">
          <a class="btn btn-danger" id="resendVerification" href="javascript:;" v-on:click="resendVerification"><i class="fa fa-fw fa-share"></i> {{ _('Resend verification email') }}</a>
        </div>
      </div>
      <div class="row tabulator-parent" v-if="detailsView">
        <div class="col-md-12 layout-column">
          <component v-if="detailsView.widget && widgetExists(detailsView.widget.type + 'Details')" :is="resolveComponent(detailsView.widget.type + 'Details')" :baseDomain="baseDomain" :apiKey="apiKey" :widget="detailsView.widget.type" :todo="todo" :isDetailsView="true" v-on:toggleDetails="toggleDetails" />
        </div>
      </div>
      <div class="row" v-else v-for="(row, index) in rows">
        <div v-for="col in row.columns" :class="'col-md-' + col.width + ' layout-column'">
          <component v-if="col.widget && widgetExists(col.widget.type)" :is="col.widget.type" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :widget="col.widget" :todo="todo" v-on:toggleDetails="toggleDetails(col)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { defineAsyncComponent } from 'vue'
import axios from 'axios'
import components from '~/lib/components'
import { IncomingOffers } from '#components'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      todo: {},
      detailsView: null,
      incomingOffers: [],
      incomingRequests: []
    }
  },
  mixins: [components],
  computed: {
    ...mapGetters(['incomingOffersShown', 'campaignCheckDone']),
    data () {
      return this.component && this.component.data ? JSON.parse(this.component.data) : {}
    },
    rows () {
      let rows = []
      let cols = []
      let total = 0
      if (this.data && this.data.columns) {
        for (let i = 0; i < this.data.columns.length; i++) {
          const col = this.data.columns[i]
          total += col.width
          if (total > 12) {
            rows.push({ columns: cols })
            cols = [col]
            total = col.width
          } else {
            cols.push(col)
          }
        }
        if (cols.length) {
          rows.push({ columns: cols })
        }
      }
      return rows
    }
  },
  methods: {
    ...mapActions([
      'setIncomingOffersShown'
    ]),
    async loadTodo () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/dashboard.json?todo=true&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.todo = response.data
    },
    async loadIncomingOffersAndRequests () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?incomingoffers=true&unprocessed=true&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      const io = response.data
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?incomingrequests=true&unprocessed=true&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.incomingOffers = io
      this.incomingRequests = response.data
      if (this.incomingOffersShown) {
        return
      }
      this.setIncomingOffersShown(true)
      if (this.incomingOffers.length || this.incomingRequests.length) {
        this.afterCampaignCheck(this.showIncomingModal)
      }
    },
    afterCampaignCheck (callback) {
      // The campaign modal goes first: wait until the page has checked the campaign feed and any campaign modal is closed
      if (this.campaignCheckDone) {
        callback()
        return
      }
      const unwatch = this.$watch('campaignCheckDone', (done) => {
        if (done) {
          unwatch()
          callback()
        }
      })
    },
    widgetExists (type) {
      switch (type) {
        case 'BestCustomers':
        case 'BestCustomersDetails':
        case 'BestSellingProducts':
        case 'BestSellingProductsDetails':
        case 'MostReservedProducts':
        case 'MostReservedProductsDetails':
        case 'HighestGrossingSalesChannels':
        case 'HighestGrossingSalesChannelsDetails':
        case 'Sales':
        case 'SalesDetails':
        case 'CumulativeSales':
        case 'CumulativeSalesDetails':
        case 'Todo':
          return true
      }
      return false
    },
    toggleDetails (col) {
      if (this.detailsView) {
        this.detailsView = null
      } else {
        this.detailsView = col
      }
    },
    showIncomingModal () {
      this.showModal('incomingoffers', IncomingOffers, {
        props: {
          incomingOffers: this.incomingOffers,
          incomingRequests: this.incomingRequests
        },
        events: {},
        handlers: {},
        width: 800
      })
    },
    async resendVerification () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/emailverification.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Sending the message failed!'))
        return
      }
      this.showNotification(this._('The message has been sent.'))
    }
  },
  components: {
    BestCustomers: defineAsyncComponent(() => import('~/components/widgets/BestCustomers')),
    BestCustomersDetails: defineAsyncComponent(() => import('~/components/widgets/BestCustomersDetails')),
    BestSellingProducts: defineAsyncComponent(() => import('~/components/widgets/BestSellingProducts')),
    BestSellingProductsDetails: defineAsyncComponent(() => import('~/components/widgets/BestSellingProductsDetails')),
    MostReservedProducts: defineAsyncComponent(() => import('~/components/widgets/MostReservedProducts')),
    MostReservedProductsDetails: defineAsyncComponent(() => import('~/components/widgets/MostReservedProductsDetails')),
    HighestGrossingSalesChannels: defineAsyncComponent(() => import('~/components/widgets/HighestGrossingSalesChannels')),
    HighestGrossingSalesChannelsDetails: defineAsyncComponent(() => import('~/components/widgets/HighestGrossingSalesChannelsDetails')),
    Sales: defineAsyncComponent(() => import('~/components/widgets/Sales')),
    SalesDetails: defineAsyncComponent(() => import('~/components/widgets/SalesDetails')),
    CumulativeSales: defineAsyncComponent(() => import('~/components/widgets/CumulativeSales')),
    CumulativeSalesDetails: defineAsyncComponent(() => import('~/components/widgets/CumulativeSalesDetails')),
    Todo: defineAsyncComponent(() => import('~/components/widgets/Todo'))
  },
  created () {
    this.loadTodo()
    this.loadIncomingOffersAndRequests()
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['restoreLeftColumn'] = (message) => {
        this.detailsView = null
      }
      this.events = events
    }
    this.enableEventBus()
  },
  beforeUnmount () {
    this.hideModal('incomingoffers')
  }
}

</script>